import axiosInstance from "../../../utils/axios";

const path = "/common"
const path2 =""

export const globalSetting = async (values) => {
    return await axiosInstance().get(`${path}/global-settings`, values);
}

export const cmsPage = async (values) => {
  return await axiosInstance().get(`${path}/cms-page`, values);
}

export const cmsOption = async (values) => {
  return await axiosInstance().post(`${path}/cms-option`, values);
}


export const Inquiry = async (values) => {
  return await axiosInstance().post(`${path}/add-inquiry`, values);
}

export const faqList = async (values) => {
  return await axiosInstance().post(`${path}/faq-list`, values);
}

export const banner = async (values) => {
  return await axiosInstance().post(`${path}/banner`, values);
}

export const GetStreamToken = async (userID, roomID) => {
  return await axiosInstance().get(`${path}/streams/getToken?userID=${userID}&roomID=${roomID}`);
};
export const GetVertexAi = async (frames) => {
  return await axiosInstance().post(`${path2}/ai`);
};






